import { useMemo } from 'react';

function useAlphaMask(texture) {
  return useMemo(() => {
    if (!texture || !texture.image)
      return { alphaData: null, width: 0, height: 0 };
    const img = texture.image;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0);
    const alphaData = ctx.getImageData(0, 0, img.width, img.height).data;
    return { alphaData, width: img.width, height: img.height };
  }, [texture]);
}

export default useAlphaMask;
